export enum SiteFiltersType {
  dateRangeTemplateType = 'dateRangeTemplateType',
  branchIds = 'branchIds',
  branchId = 'branchId',
  agentBranchIds = 'agentBranchIds',
  groupIds = 'groupIds',
  serviceAreaIds = 'serviceAreaIds',
  serviceStatusGroup = 'serviceStatusGroup',
  accountIds = 'accountIds',
  billingAccountIds = 'billingAccountIds',
  billingOrderStatus = 'billingOrderStatus',
  logisticsVehicleStatus = 'logisticsVehicleStatus',
  depotIds = 'depotIds',
  customerIds = 'customerIds',
  supplyAccountIds = 'supplyAccountIds',
  agentIds = 'agentIds',
  agentType = 'agentType',
  employmentType = 'employmentType',
  agentStatus = 'agentStatus',
  agentSkills = 'agentSkills',
  serviceSkills = 'serviceSkills',
  agentScheduleIds = 'agentScheduleIds',
  serviceTypes = 'serviceTypes',
  programTypes = 'programTypes',
  dispatchQuoteTypes = 'dispatchQuoteTypes',
  tags = 'tags',
  resourceTags = 'resourceTags',
  vehicleTypes = 'vehicleTypes',
  vehicleTypeIds = 'vehicleTypeIds',
  labels = 'labels',
  riskTypes = 'riskTypes',
  packagesIds = 'packagesIds',
  fulfillmentDisplayStatus = 'fulfillmentDisplayStatus',
  fulfillmentStepStatus = 'fulfillmentStepStatus',
  fulfillmentStepDisplayStatus = 'fulfillmentStepDisplayStatus',
  logisticsVehicleIds = 'logisticsVehicleIds',
  billingOrderInvoiceStatuses = 'billingOrderInvoiceStatuses',
  approvalStatuses = 'approvalStatuses',
  fulfillmentMileType = 'fulfillmentMileType',
  attempts = 'attempts',
  agentAssistant = 'agentAssistant',
  isPacked = 'isPacked',
  isSynced = 'isSynced',
  packingStatus = 'packingStatus',
  packingStatuses = 'packingStatuses',
  isActive = 'isActive',
  sessionRecording = 'sessionRecording',
  termsApproved = 'termsApproved',
  isArchived = 'isArchived',
  schedulingRequired = 'schedulingRequired',
  obligateTimeWindow = 'obligateTimeWindow',
  timeToDeliver = 'timeToDeliver',
  isReturnDelivery = 'isReturnDelivery',
  noFromLocation = 'noFromLocation',
  noToLocation = 'noToLocation',
  isMissingPackages = 'isMissingPackages',
  isConsolidated = 'isConsolidated',
  inRoute = 'inRoute',
  filterByCreatedAt = 'filterByCreatedAt',
  hasPrice = 'hasPrice',
  displayStatusGroups = 'displayStatusGroups',
  providerTypes = 'providerTypes',
  dispatchType = 'dispatchType',
  gpsStatus = 'gpsStatus',
  gpsPermissions = 'gpsPermissions',
  routeStatuses = 'routeStatuses',
  statuses = 'statuses',
  omsOrderStatuses = 'omsOrderStatuses',
  commissionDelta = 'commissionDelta',
  addressQualities = 'addressQualities',
  hasScheduledTasks = 'hasScheduledTasks',
  hasResourceAllocation = 'hasResourceAllocation',
  reasonType = 'reasonType',
  relationTypes = 'relationTypes',
  schedulingSmsStatuses = 'schedulingSmsStatuses',
  surveyScore = 'surveyScore',
  query = 'query',
  recurringType = 'recurringType',
  scheduleTypes = 'scheduleTypes',
  weekDays = 'weekDays',
  taskAccountIds = 'taskAccountIds',
  leftoverConstrains = 'leftoverConstrains',
  teamIds = 'teamIds',
  segment = 'segment',
  agentSource = 'agentSource',
  states = 'states',

  ///////////////////////////////////
  // Sub Filters
  ///////////////////////////////////
  noArea = 'noArea',
  serviceAreaPickup = 'serviceAreaPickup',
  serviceAreaDropoff = 'serviceAreaDropoff',
  depotPickup = 'depotPickup',
  depotDropoff = 'depotDropoff',
  accountPickup = 'accountPickup',
  accountDropoff = 'accountDropoff',
  serviceAreasServiceTypes = 'serviceAreasServiceTypes',
  noPickUpArea = 'noPickUpArea',
  noDropOffArea = 'noDropOffArea',
  noBranches = 'noBranches',
  resourceIds = 'resourceIds',
  groups = 'groups',
  ////// package config related. need to use 3 of them //////
  configuredPackageField = 'configuredPackageField',
  configuredFieldName = 'configuredFieldName',
  configuredFieldValue = 'configuredFieldValue',
  ///////////////////////////////////////////////////////////
  noPickUpDepot = 'noPickUpDepot',
  noDropOffDepot = 'noDropOffDepot',
  noPickUpAccount = 'noPickUpAccount',
  noDropOffAccount = 'noDropOffAccount',
  cluster = 'cluster'
}
